var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPresentation = function SvgIconPresentation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 2.25a1 1 0 1 0-2 0V3.5H3.75A1.75 1.75 0 0 0 2 5.25V16.5c0 .966.784 1.75 1.75 1.75h3.17l-1.7 2.125a1 1 0 0 0 1.56 1.25l2.7-3.375h5.04l2.7 3.375a1 1 0 1 0 1.56-1.25l-1.7-2.125h3.17A1.75 1.75 0 0 0 22 16.5V5.25a1.75 1.75 0 0 0-1.75-1.75H13zM4 5.5v10.75h16V5.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconPresentation;